<template>
  <router-view />
  <Analytics />
</template>

<script setup>
import { Analytics } from '@vercel/analytics/vue'
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
/*  height: 100%;*/
  margin: 0;
}
html, body {
  margin: 0;
  padding: 0;
  width: 100%;
/*  height: 100%;*/
}
</style>
